import { capitalCase } from 'capital-case';
import React from 'react';
import SplitPane from 'react-split-pane';
import { useLocalStorage } from 'react-use';
import styled from 'styled-components';
import { CloseButton } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { DropButton } from '../../../ui/DropButton';
import { PopupTabs } from '../../../ui/PopupTabs';
import { FlexScroller } from '../../../ui/Scrollers';
import { Shadows } from '../../../ui/Standards';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { EditorSession } from '../EditorSession';
import { createObserver } from '../ExtendableStore';
import { Colors, remInPx } from './../../../ui';
import { developerToggle } from './DeveloperCommands';
import { DeveloperComputePanel } from './DeveloperComputePanel';
import { DeveloperHistoryInfo } from './DeveloperHistoryInfo';
import { DeveloperLensPanel } from './DeveloperLensPanel';
import { DeveloperModelInfo } from './DeveloperModelInfo';
import { DeveloperSessionInfo } from './DeveloperSessionInfo';
import { DeveloperWelcomeInfo } from './DeveloperWelcomeInfo';
import { IsDeveloperMode } from './IsDeveloperMode';

const XSplitPane = SplitPane as any;

const Inner = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    padding: 1rem 5.5rem 5.5rem 0;

    & > * {
        pointer-events: all;
    }
`;

const EnabledObserver = createObserver(IsDeveloperMode);

const Tabs = [
    ['welcome', DeveloperWelcomeInfo] as const,
    ['compute', DeveloperComputePanel] as const,
    ['lens', DeveloperLensPanel] as const,
    ['session', DeveloperSessionInfo] as const,
    ['model', DeveloperModelInfo] as const,
    ['history', DeveloperHistoryInfo] as const,
];

export const DeveloperView = () => {

    const dispatch = useResolve(CommandDispatcher);
    const session = useResolve(EditorSession);

    const [size, setSize] = useLocalStorage('deqo/editor/devSize', remInPx(20));
    const [menu, setMenu] = useLocalStorage('deqo/editor/devMenu', 'welcome');

    return <EnabledObserver store={session} render={enabled => enabled &&
        <Flexer inset="0" pointerEvents="none" zIndex="1">
            <XSplitPane split="vertical" primary="second" minSize={remInPx(10)} size={size} onChange={setSize}>
                <div></div>
                <Inner>
                    <Flexer flex="column" width="100%" background="white" borderRadius=".25" boxShadow={Shadows.xl} border={`solid 1px ${Colors.gray50}`}>
                        <FlexScroller>
                            <PopupTabs padding="1 1 0 1">
                                {Tabs.map(([key]) =>
                                    <PopupTabs.Item key={key} selected={menu === key} onClick={() => setMenu(key)}>{capitalCase(key)}</PopupTabs.Item>
                                )}
                                <Flexer margin="0 0 0 auto">
                                    <DropButton onClick={() => dispatch(developerToggle)}>
                                        <CloseButton />
                                    </DropButton>
                                </Flexer>
                            </PopupTabs>
                            <Flexer padding={1}>
                                {Tabs.map(([key, view]) => key === menu && React.createElement(view, { key }))}
                            </Flexer>
                        </FlexScroller>
                    </Flexer>
                </Inner>
            </XSplitPane>
        </Flexer>} />;
};

